// Configurações de serviços adicionais (hardcoded)
// Aqui você pode ajustar os preços e mapeamentos de ids dos produtos do Supabase

export const SERVICO_IDS = {
  LIVRO: 85665,
  CAPA: 85666,
  ISBN: 87453,
  AMAZON: 104560,
  TRADUCAO: 94680,
} as const

export const PRECO_SERVICO = {
  LIVRO: 49.9,
  CAPA: 99.9,
  ISBN: 199.9,
  AMAZON: 199.9,
  TRADUCAO: 99.9,
} as const

export const COMBO = {
  descontoPercentual: 20, // 20% sobre os itens faltantes
}

export type ServicoKey = keyof typeof SERVICO_IDS

export function calcularPrecoCombo(servicos: { [K in ServicoKey]?: boolean }) {
  const faltantes: ServicoKey[] = [];
  (Object.keys(SERVICO_IDS) as ServicoKey[]).forEach((k: ServicoKey) => {
    if (!servicos[k]) faltantes.push(k);
  });

  const soma = faltantes.reduce((acc, k) => acc + PRECO_SERVICO[k], 0);
  const desconto = (soma * COMBO.descontoPercentual) / 100;
  const totalComDesconto = Math.max(0, soma - desconto);

  return { faltantes, subtotal: soma, desconto, total: totalComDesconto };
}